import axios from "axios";
const baseURL = process.env.REACT_APP_BASE_URL;

// SkillSection Container
// Returning an array of objects, storing skills and ids
export const getSkillsList = async (auth_key) => {
    const response = await axios.get(`${baseURL}/skills-list`, {
        headers: {
            "Content-Type": "application/json",
            "auth_key": auth_key
        }
    });
    return response?.data?.data;
}

// Testimonials Container
// Returning an array of objects, storing testimonials
export const getTestimonialsList = async ({auth_key}) => {
    const response = await axios.get(`${baseURL}/testimonials-list`, {
        headers: {
            "Content-Type": "application/json",
            "auth_key": auth_key    
        }
    })
    return response?.data?.data;
}

export const getEmployeeTestimonialsList = async ({auth_key}) => {
    const response = await axios.get(`${baseURL}/employee-testimonials-list`, {
        headers: {
            "Content-Type": "application/json",
            "auth_key": auth_key
        }
    })
    return response?.data?.data;
}

// Jobs Listing Container 
// Returning an array of objects, storing job listings
export const getJobsList = async ({auth_key, bodyData}) => {
    const response = await axios.post(`${baseURL}/jobs-list`, bodyData, {
        headers: {
            "Content-Type": "application/json",
            "auth_key": auth_key
        }
    })
    return response?.data?.data;
}

// Job Description Container
// Returning an object, storing job description
export const getJobDetail = async ({auth_key, jobId, preview}) => {
    const response = await axios.get(`${baseURL}/jobs-detail?jobId=${jobId}&preview=${preview}`, {
        headers: {
            "Content-Type": "application/json",
            "auth_key": auth_key
        }
    })
    return response?.data?.data;
}

// Apply for job 
// Submitting the form data
export const applyForJob = async ({auth_key, finalFormData}) => {
    const response = await axios.post(`${baseURL}/apply-job`, finalFormData, {
        headers: {
            "auth_key": auth_key
        }
    })
    return response?.data?.message;
}
// upload your resume
export const uploadResume = async ({auth_key, finalFormData}) => {
    const response = await axios.post(`${baseURL}/apply-without-job`, finalFormData, {
        headers: {
            "auth_key": auth_key
        }   
    })
    return response?.data?.data;
}

// Hire a Talent
// Submitting a hiring request
export const addHireRequest = async ({auth_key, finalFormData}) => {
    const response = await axios.post(`${baseURL}/add-hiring-request`, finalFormData, {
        headers: {
            "auth_key": auth_key
        }
    })
    return response?.data?.data;
}

// Roles List
// Get roles list
export const getRolesList = async ({auth_key}) => {
    const response = await axios.get(`${baseURL}/roles-list`, {
        headers: {
            "auth_key": auth_key
        }
    })
    return response?.data?.data;
}

// Blogs List
// Returning an array of objects, storing blog's details
export const getBlogsList = async ({auth_key, bodyData}) => {
    const response = await axios.post(`${baseURL}/blogs-list`, bodyData, {
        headers: {
            "Content-Type": "application/json",
            "auth_key": auth_key
        }
    })
    return response?.data?.data;
}

// Blog Detail
// Returning an object, storing blog's details
export const getBlogDetail = async ({auth_key, blogId, preview}) => {

    const response = await axios.get(`${baseURL}/blog-detail?blogId=${blogId}&preview=${preview}`, {
        headers: {
            "Content-Type": "application/json",
            "auth_key": auth_key
        }
    })
    return response?.data?.data;
}

// Client Logos
export const getClientLogos = async ({auth_key}) => {

    const response = await axios.get(`${baseURL}/clients-list`, {
        headers: {
            "Content-Type": "application/json",
            "auth_key": auth_key
        }
    })    
    return response?.data?.data;
}

// Gallery List
export const getImages = async ({auth_key}) => {
    const response = await axios.get(`${baseURL}/gallery-list`, {
        headers: {
            "Content-Type": "application/json",
            "auth_key": auth_key
        }
    })
    return response?.data?.data;
}

// Employee List 
export const getEmployeesList = async ({auth_key}) => {

    const response = await axios.get(`${baseURL}/employes-list`, {
        headers: {
            "Content-type": "application/json",
            "auth_key": auth_key
        }
    });
    return response?.data?.data;
}

